module.exports = __webpack_public_path__ + "img/voice-thumb6.f87a49e.jpg";